import React from 'react';
import { H2, NamedLink } from '../../../components';

import css from './SectionCancellingBooking.module.css';
import classNames from 'classnames';

const items = [
  { id: 'HowItWorks.cancellingBookings.item1' },
  { id: 'HowItWorks.cancellingBookings.item2' },
  { id: 'HowItWorks.cancellingBookings.item3' },
  { id: 'HowItWorks.cancellingBookings.item4' },
  { id: 'HowItWorks.cancellingBookings.item5' },
];

const SectionCancellingBooking = props => {
  const { intl, className, titleClassName } = props;

  return (
    <div className={classNames(css.root, className)}>
      <H2 className={titleClassName}>
        {intl.formatMessage(
          { id: 'HowItWorks.cancellingBookings.heading' },
          { span: text => <span className={css.marketplaceColoredText}>{text}</span> }
        )}
      </H2>
      <div className={css.contentWrapper}>
        <p className={css.paragraph}>
          {intl.formatMessage({ id: 'HowItWorksPage.cancellingBookings.paragraph' })}
        </p>
        <ul className={css.textList}>
          {items.map(textId => (
            <li key={textId.id} className={css.textItem}>
              {intl.formatMessage(
                { id: textId.id },
                { span: text => <span className={css.bold}>{text}</span> }
              )}
            </li>
          ))}
        </ul>
        <div className={css.bottom}>
          <span>
            {intl.formatMessage(
              { id: 'HowItWorksPage.cancellingBookings.moreInfo' },
              { link: text => <NamedLink name="TermsOfServicePage">{text}</NamedLink> }
            )}
          </span>
          <span>
            {intl.formatMessage(
              { id: 'HowItWorksPage.cancellingBookings.questions' },
              { link: mail => <a href={`mailto: ${mail}`}>{mail} </a> }
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SectionCancellingBooking;
